(function () {
  'use strict';

  function initCountdown(root) {
    var nodes = root.querySelectorAll('[data-nv-countdown]');
    nodes.forEach(function (node) {
      if (node.dataset.nvReady === 'true') return;
      node.dataset.nvReady = 'true';
      var total = Number(node.dataset.duration || 0);
      if (!total) return;
      var remaining = total;
      var hours = node.querySelector('[data-hours]');
      var minutes = node.querySelector('[data-minutes]');
      var seconds = node.querySelector('[data-seconds]');
      function render() {
        if (remaining < 0) remaining = total;
        if (hours) hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        if (minutes) minutes.textContent = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
        if (seconds) seconds.textContent = String(remaining % 60).padStart(2, '0');
        remaining -= 1;
      }
      render();
      node.nvTimer = window.setInterval(render, 1000);
    });
  }

  function initResults(root) {
    root.querySelectorAll('[data-nv-results]').forEach(function (section) {
      if (section.dataset.nvReady === 'true') return;
      section.dataset.nvReady = 'true';
      var track = section.querySelector('[data-track]');
      var filters = Array.from(section.querySelectorAll('[data-filter]'));
      var cards = Array.from(section.querySelectorAll('[data-category]'));
      var prev = section.querySelector('[data-prev]');
      var next = section.querySelector('[data-next]');
      var index = 0;

      function visibleCards() { return cards.filter(function (card) { return !card.hidden; }); }
      function render() {
        var visible = visibleCards();
        var perView = window.matchMedia('(max-width: 768px)').matches ? 1 : 3;
        index = Math.max(0, Math.min(index, Math.max(0, visible.length - perView)));
        var target = visible[index];
        track.style.transform = target ? 'translateX(-' + target.offsetLeft + 'px)' : '';
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index >= Math.max(0, visible.length - perView);
      }
      function filter(value, button) {
        cards.forEach(function (card) { card.hidden = value !== 'all' && card.dataset.category !== value; });
        filters.forEach(function (item) { item.classList.toggle('is-active', item === button); });
        index = 0;
        window.requestAnimationFrame(render);
      }
      filters.forEach(function (button) { button.addEventListener('click', function () { filter(button.dataset.filter, button); }); });
      if (prev) prev.addEventListener('click', function () { index -= 1; render(); });
      if (next) next.addEventListener('click', function () { index += 1; render(); });
      window.addEventListener('resize', render, { passive: true });
      render();
    });
  }

  function initBeforeAfter(root) {
    root.querySelectorAll('[data-nv-before-after]').forEach(function (section) {
      if (section.dataset.nvReady === 'true') return;
      section.dataset.nvReady = 'true';
      var slider = section.querySelector('.nv-before-after__slider');
      var range = section.querySelector('[data-range]');
      if (!slider || !range) return;
      function update() { slider.style.setProperty('--nv-ba-position', range.value + '%'); }
      range.addEventListener('input', update);
      update();
    });
  }

  function initCarousel(root) {
    root.querySelectorAll('[data-nv-carousel]').forEach(function (section) {
      if (section.dataset.nvReady === 'true') return;
      section.dataset.nvReady = 'true';
      var cards = Array.from(section.querySelectorAll('[data-card]'));
      var prev = section.querySelector('[data-prev]');
      var next = section.querySelector('[data-next]');
      var index = 0;
      if (!cards.length) return;

      function render() {
        cards.forEach(function (card, cardIndex) {
          card.classList.remove('is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next');
          var diff = cardIndex - index;
          if (diff < -cards.length / 2) diff += cards.length;
          if (diff > cards.length / 2) diff -= cards.length;
          if (diff === 0) card.classList.add('is-active');
          if (diff === -1) card.classList.add('is-prev');
          if (diff === 1) card.classList.add('is-next');
          if (diff === -2) card.classList.add('is-far-prev');
          if (diff === 2) card.classList.add('is-far-next');
          var video = card.querySelector('video');
          if (video && diff !== 0) video.pause();
        });
      }
      function move(delta) { index = (index + delta + cards.length) % cards.length; render(); }
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      cards.forEach(function (card, cardIndex) { card.addEventListener('click', function (event) { if (cardIndex !== index && !event.target.closest('a,button,video')) { index = cardIndex; render(); } }); });
      var startX = 0;
      var stage = section.querySelector('[data-stage]');
      if (stage) {
        stage.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (event) { var distance = startX - event.changedTouches[0].clientX; if (Math.abs(distance) > 45) move(distance > 0 ? 1 : -1); }, { passive: true });
      }
      render();
    });
  }

  function init(root) {
    initCountdown(root);
    initResults(root);
    initBeforeAfter(root);
    initCarousel(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
